// extracted by mini-css-extract-plugin
export default {"Content":"Content_Content__kNHG3","HomeContent":"Content_HomeContent__zxv3q","itemCard":"Content_itemCard__FJC1X"};